import { render, staticRenderFns } from "./AgendaModalSpostaAppuntamento.vue?vue&type=template&id=55e1b6d2"
import script from "./AgendaModalSpostaAppuntamento.vue?vue&type=script&lang=js"
export * from "./AgendaModalSpostaAppuntamento.vue?vue&type=script&lang=js"
import style0 from "./AgendaModalSpostaAppuntamento.vue?vue&type=style&index=0&id=55e1b6d2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports